import type { JSX } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound(): JSX.Element {
  return (
    <main className="grid min-h-[70vh] place-items-center px-6 text-center">
      <div className="space-y-4">
        <h1 className="text-3xl font-bold">404 — Not found</h1>
        <p className="text-muted-foreground">
          That roast doesn't exist or you don't have access.
        </p>
        <Button asChild>
          <Link to="/">Go home</Link>
        </Button>
      </div>
    </main>
  );
}
